'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var FBEmbedVideo = (function (_Component) {
  _inherits(FBEmbedVideo, _Component);

  function FBEmbedVideo() {
    _classCallCheck(this, FBEmbedVideo);

    _get(Object.getPrototypeOf(FBEmbedVideo.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(FBEmbedVideo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props;
      var appId = _props.appId;
      var locale = _props.locale;
      var version = _props.version;
      var xfbml = _props.xfbml;

      window.fbAsyncInit = function () {
        FB.init({ // eslint-disable-line no-undef
          appId: appId,
          xfbml: xfbml,
          version: version
        });
      };

      // Load the SDK asynchronously
      (function (d, s, id) {
        // eslint-disable-line id-length
        var element = d.getElementsByTagName(s)[0];
        var fjs = element;
        var js = element;
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);js.id = id;
        js.src = '//connect.facebook.net/' + locale + '/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (window.FB) {
        window.FB.XFBML.parse();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var href = _props2.href;
      var width = _props2.width;

      return _react2['default'].createElement(
        'span',
        null,
        _react2['default'].createElement('div', { id: 'fb-root' }),
        _react2['default'].createElement('div', { className: 'fb-post', 'data-href': href, 'data-width': width })
      );
    }
  }], [{
    key: 'propTypes',
    value: {
      appId: _react.PropTypes.string.isRequired,
      href: _react.PropTypes.string.isRequired,
      locale: _react.PropTypes.string,
      version: _react.PropTypes.string,
      width: _react.PropTypes.number,
      xfbml: _react.PropTypes.bool
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      locale: 'en_US',
      version: 'v2.5',
      width: 500,
      xfbml: true
    },
    enumerable: true
  }]);

  return FBEmbedVideo;
})(_react.Component);

exports['default'] = FBEmbedVideo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/facebook-plugins/lib/FBEmbedVideo.js
// module id = 1183
// module chunks = 1